
    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component
    export default class SectionHeading extends Vue {
        @Prop({default:''}) count:any;
        @Prop() headingText:any;
        @Prop({default:false}) hasbackground:any;
    }
